// @ts-nocheck
import { initialState } from './reducer';
import * as constants from './constants';

const parametersSelector = (state) => state.parameters || initialState;

export const getSelectedGroupParameters = (state, selectedGroupId) => parametersSelector(state)[selectedGroupId];

export const getParamterDetails = (state, parameterMasterId) => parametersSelector(state).details[parameterMasterId];

export const isLoading = (state: any, eventName: string): boolean => {
	const data = parametersSelector(state);

	return data.isLoading[eventName];
};
